import styled, {css,keyframes} from 'styled-components';

  
export const LeftRightFrame = keyframes`
    0% {
        transform:translateX(-100%);
    }
    50% {
        transform:translateX(0%);
    }
    100% {
        transform:translateX(100%);
    }
`;


export const LoaderMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        max-width:120rem;
        margin: 0 auto;
    `
)

export const LoaderMainInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        height: 40rem;
        align-items: center;
        justify-content: center;
        background-color: ${props.theme.colors.white.base};
        border-radius: 1rem;
        box-shadow: 0 6px 30px 0 rgba(0,0,0,0.2);
        z-index: 1;
        margin: ${props.margin};
    `
);

export const LoaderDiv = styled.div(
    props => css`
        width:30rem;
        height:0.5rem;
        border-radius: .4rem;
        background-color: ${props.theme.colors.grey.lighte7};
        overflow-x:hidden;
        position:absolute;
        top:65%;
        left:50%;
        transform:translate(-50%,-50%);
        &:before {
            animation: ${LeftRightFrame} 3s infinite;
            background-image:linear-gradient(to right, transparent, ${props.theme.colors.blue.base}, transparent);
             content:"";
            height:0.5rem;
            left:0;
            overflow:hidden;
            position:absolute;
            right:0;
            top:0;
        }
        &:after {
            content:"";
            height:0.5rem;
            left:0;
            overflow:hidden;
            position:absolute;
            right:0;
            top:0;
        }
    
    `
)

